module.exports = __webpack_public_path__ + "static/media/banner1.b5b99413.png";